import React from 'react';

import { TableCell, TableRow } from '@mui/material';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { DATE_FORMAT } from '../../../../constants/date.constant';
import { ISalesDetails, ISalesDetailsRegistration } from '../../../../types/sales-details.type';
import { ArrayUtils } from '../../../../utils/array.utils';
import { DateUtils } from '../../../../utils/date.utils';
import { SALES_DETAILS_PAYMENTS } from '../../constants';

interface IProps {
  detail: Omit<ISalesDetails, 'registrations'>;
  registration: ISalesDetailsRegistration;
}

const SalesDetailsListRegistration = React.memo(({ detail, registration }: IProps) => {
  const { t } = useTranslation();

  const date = dayjs(detail.date);
  const year = date.format('YYYY');

  return (
    <TableRow sx={{ backgroundColor: '#E8E8E8', '& td': { textAlign: 'center' } }}>
      <TableCell>{t(`school.${detail.school}`)}</TableCell>
      <TableCell>{detail.schoolYear}</TableCell>
      <TableCell>{date.format(DATE_FORMAT)}</TableCell>
      <TableCell>{detail.number}</TableCell>

      <TableCell>
        {DateUtils.getWeekOfYear(date)} - {year}
      </TableCell>

      <TableCell>
        {DateUtils.getMonthName(date)} - {year}
      </TableCell>

      <TableCell>{detail.customer}</TableCell>
      <TableCell>{detail.email}</TableCell>
      <TableCell>{detail.deliveryCountry}</TableCell>
      <TableCell>{registration.partnership}</TableCell>
      <TableCell>{registration.student}</TableCell>
      <TableCell>{t(`general.${registration.registrationType}`)}</TableCell>
      <TableCell>{registration.status}</TableCell>
      <TableCell>{registration.schoolLevel}</TableCell>
      <TableCell>{t(`product_type.${registration.productType.toLowerCase()}`)}</TableCell>
      <TableCell>{registration.duration}</TableCell>

      {ArrayUtils.makeRange(SALES_DETAILS_PAYMENTS + 11).map((number) => (
        <TableCell key={`${detail.number}_empty_registration_${number}`} />
      ))}
    </TableRow>
  );
});

export default SalesDetailsListRegistration;
